module.exports = __webpack_public_path__ + "static/media/u35_5.b0540819.mp3";